var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exam-tip-container"},[_c('div',{staticClass:"title"},[_vm._v("\n    Tip\n  ")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.examTip)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }